/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Merchant, StatementOptions } from "../../../../models";
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { UploadLogoModalComponent } from "../upload-logo-modal/upload-logo-modal.component";
import { SafeUrl } from "@angular/platform-browser";
import { StatementService } from "../../../../services";

@Component({
  selector: "app-edit-e-statement-opitons",
  templateUrl: "./edit-e-statement-options.component.html"
})
export class EditEStatementOptionsComponent {
  @Input() parentGroup!: FormGroup;
  @Input("merchant") merchant!: Merchant;
  @Input() logoImage!: SafeUrl;
  modalRef?: BsModalRef;

  constructor(private modalService: BsModalService, private statementService: StatementService) {}

  get statementFormControls() {
    return this.parentGroup.controls;
  }

  updateInsuranceAgingCheckbox() {
    if (!this.statementFormControls.displayAgingBoxes.value) {
      this.statementFormControls.displayInsuranceAgingBoxes.setValue(false);
      this.statementFormControls.displayInsuranceAgingBoxes.disable();
    } else {
      this.statementFormControls.displayInsuranceAgingBoxes.enable();
    }
  }

  updateReturnByMailCheckbox() {
    if (!this.statementFormControls.payOrBillByMoneyOrder.value && !this.statementFormControls.payOrBillByCheck.value) {
      this.statementFormControls.displayDetachReturnByMail.setValue(false);
      this.statementFormControls.displayDetachReturnByMail.disable();
    } else {
      this.statementFormControls.displayDetachReturnByMail.enable();
    }
  }

  openLogoUploadDialog(): void {
    const initialState: ModalOptions = {
      initialState: {
        merchantId: this.merchant.id
      }
    };
    this.modalRef = this.modalService.show(UploadLogoModalComponent, initialState);
    this.modalRef.content.event.subscribe((logo: SafeUrl) => {
      this.logoImage = logo;
      this.statementService
        .getStatementOptions(this.merchant.id)
        .subscribe((statements: { [index: string]: string }) => {
          this.merchant.statementOptions = statements;
          this.parentGroup.patchValue({ merchantLogoFilename: statements[StatementOptions.merchantLogoFileName] });
        });
    });
  }
}
